
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forum/[forum]/[postID]",
      function () {
        return require("private-next-pages/forum/[forum]/[postID].tsx");
      }
    ]);
  